/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_ResultInputs */

const en_wb_management_result = /** @type {(inputs: Wb_Management_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open decisions and handoffs in one place, with enough context to take the next step.`)
};

const lv_wb_management_result = /** @type {(inputs: Wb_Management_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neizlemtie jautājumi un nododamie darbi vienuviet, ar pietiekamu kontekstu nākamajam solim.`)
};

/**
* | output |
* | --- |
* | "Open decisions and handoffs in one place, with enough context to take the next step." |
*
* @param {Wb_Management_ResultInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_result = /** @type {((inputs?: Wb_Management_ResultInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_ResultInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_result(inputs)
	return en_wb_management_result(inputs)
});